import { Button } from '@/components/ui';
import React, { FC } from 'react';
import { BUTTON_STYLES } from '@/components/ui/Buttons/utils';
import { TypeModalFields } from '@/core/generated-types';
import { SubscriberShopModalWrapper } from '../SubscriberShop';
import { TypeSubscriberShopPageTranslations } from '@/utils/translations';
import { UniversalCta } from '../UniversalCta';

interface SiblingsErrorModalProps extends TypeModalFields {
  isOpen: boolean;
  handleClose: () => void;
  translations: TypeSubscriberShopPageTranslations;
}

const SiblingsErrorModal: FC<SiblingsErrorModalProps> = ({
  isOpen,
  handleClose,
  translations,
  ...props
}) => {
  const { primaryCta } = props;
  const { keepShoppingCta } = translations;

  const primaryButton = primaryCta ? (
    <UniversalCta
      link={primaryCta}
      className="mb-4 h-auto w-full md:w-[300px]"
    />
  ) : null;

  const secondaryButton = (
    <Button
      ctaText={keepShoppingCta}
      style={BUTTON_STYLES.secondary}
      classes="mb-4 h-auto w-full md:w-[300px]"
      onClick={handleClose}
    />
  );

  const ctaButtons = [primaryButton, secondaryButton].filter(Boolean);

  return (
    <SubscriberShopModalWrapper
      isOpen={isOpen}
      handleClose={handleClose}
      ctaButtons={ctaButtons}
      {...props}
    />
  );
};

export default React.memo(SiblingsErrorModal);
